module.exports = __webpack_public_path__ + "static/img/sec2-cont-main@m.8b97bef.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/sec2-cont-main@m.jpg
// module id = t+Le
// module chunks = 0